import { render, staticRenderFns } from "./CadCliente.vue?vue&type=template&id=94cb0b60&scoped=true"
import script from "./CadCliente.vue?vue&type=script&lang=js"
export * from "./CadCliente.vue?vue&type=script&lang=js"
import style0 from "./CadCliente.vue?vue&type=style&index=0&id=94cb0b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cb0b60",
  null
  
)

export default component.exports